export function getData(response, successCode = 0) {
    const { data } = response
    if (data.code === successCode) {
        return data.data
    } else {
        throw data
    }
}

/**
 * 解析接口响应错误，返回用户更容易阅读的文字·
 * @param e
 * @return {string|*|string}
 */
export function parseError(e) {
    const handle = () => {
        if (!e) {
            return e
        }
        if (e.tips || e.message || e.msg) {
            return e.tips || e.message || e.msg
        }
        try {
            return JSON.stringify(e)
        }catch (_) {
            return e
        }
    }

    const result = handle()
    try {
        if (result && result.toLowerCase().indexOf('network') !== -1) {
            return '网络错误'
        }
        return result
    } catch (e) {
        return result
    }
}



// WEBPACK FOOTER //
// ./src/api/util.js